export const getUrl = (host: string, path: string, search?: string): string => {
    const result = new URL(host);

    if (path) {
        result.pathname = path;
    }

    if (search) {
        result.search = search;
    }

    return result.toString();
};
